/* eslint-disable no-prototype-builtins */
/* eslint-disable max-nested-callbacks */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-redeclare */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/adjacent-overload-signatures */
/* eslint-disable max-nested-callbacks */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
import dayjs from 'dayjs'

import { cloneDeep, pick } from 'lodash-es'

import HSwitch from '@/components/NewEditForm/UILibrary/HYBVant/HSwitch'
import { isType, findValuesByKeys } from '@/utils'

import { dateFormat, monthFormat, weekFormat, dateFormatMap } from '../enum'
// 保存日期转化
export const formatDate = (info: any, bool?: boolean) => {
  const text = bool ? weekFormat : dateFormat
  return info ? info?.format(text) : null
}

export const _formatDate = (info: any, type = 'date') => {
  const text = dateFormatMap[type]
  return info ? info?.format(text) : null
}
// 回显日期转化
export const echoFormatDate = (info: any, bool?: boolean) => {
  const text = bool ? weekFormat : dateFormat
  return info ? dayjs(dayjs(info).format(text)) : null
}
/**
 * 使用标识符丰富并组织图片数据。
 *
 * @param images - 图片资源数组。
 * @param typeId - 用于标注图片类型的标识符。
 * @returns 如果图片数组非空，则返回一个包含类型和图片详情的对象；否则，返回空数组。
 */
export function organizeImagesWithDetails(images: string[], typeId: number): any[] | [] {
  // 确保输入是图片URL数组
  if (!Array.isArray(images)) {
    return []
  }
  // 仅当有图片时构建丰富数据结构
  return images.length > 0
    ? [
        {
          type: typeId,
          details: [{ oss_key: images }]
        }
      ]
    : []
}
/*
 * 检查给定对象是否为Moment.js的时间对象。
 * Moment.js是一个流行的JavaScript日期库，用于处理和格式化日期和时间。这个函数提供了一种方式来验证一个对象是否是Moment.js的时间对象。
 * 这对于需要与Moment.js时间对象交互的函数或方法非常有用，可以确保传入的对象是预期的类型。
 * @param obj 要检查的对象。它可以是任何类型的对象。
 * @returns 如果obj是Moment.js的时间对象，则返回true；否则返回false。
 */
export function isMoment(obj: any) {
  return dayjs.isDayjs(obj)
}
export function isArray(obj: any) {
  return Array.isArray(obj)
}
/**
 * 将输入转换为数组形式。
 * 此函数接受一个任意类型的对象作为输入，并尝试将其转换为数组。如果输入已经是数组，它将直接返回该数组。
 * 如果输入不是数组但存在（即，不是null或undefined），则将其包装在一个数组中并返回。如果输入不存在，则返回null。
 * @param obj 输入对象，可以是任何类型。
 * @returns 如果obj是数组，直接返回obj；如果obj存在但不是数组，返回包含obj的单元素数组；如果obj不存在，返回null。
 */
export function convertToArr(obj: any) {
  if (isArray(obj)) {
    return obj
  }
  if (obj) {
    return [obj]
  }
  return null
}
/**
 * 自定义格式化日期显示。
 * 此函数接受一个日期信息 `dateInfo` 和一个可选的日期格式字符串 `text`。
 * 它将 `dateInfo` 根据提供的格式（或默认的 'YYYY-MM-DD' 格式，如果未提供）转换为易读的日期字符串。
 * 如果 `dateInfo` 为空或无效，则返回 `null`。
 * @param {any} dateInfo - 需要格式化的日期对象或时间戳。
 * @param {string} [dateFormat='YYYY-MM-DD'] - 用于格式化的日期格式字符串，默认为年月日格式。
 * @returns {any | null} - 格式化后的 `dayjs` 对象，如果输入无效则返回 `null`。
 */
export const transformAndEchoDate = (dateInfo: any, dateFormat?: string) => {
  return dateInfo ? dayjs(dayjs(dateInfo).format(dateFormat || 'YYYY-MM-DD')) : null
}
/**
 * 格式化日期信息并输出。
 * 此函数接收一个日期对象（info）和一个可选的日期格式字符串（text）。若日期对象存在且非空，
 * 则将日期对象按照指定格式（默认为'YYYY-MM-DD'）进行格式化并返回；否则返回null。
 * @param dateInfo 日期对象，通常是日期时间实例。
 * @param [dateFormat] 日期格式字符串，用于自定义日期显示格式。如未提供，则使用默认格式'YYYY-MM-DD'。
 * @returns 格式化后的日期字符串，或在日期对象不存在时返回null。
 */
export const formatAndEchoDate = (dateInfo: any, dateFormat?: string) => {
  return dateInfo ? dayjs(dateInfo).format(dateFormat || 'YYYY-MM-DD') : null
}
/**
 * 确保返回值为数组或单个值。
 * 如果输入值已经是数组，则直接返回该数组；
 * 如果输入值为非数组且不为空，则返回包含该值的数组；
 * 如果输入值为null或undefined，则返回null。
 * 这个函数的主要用途是在处理数据时提供统一的输出格式， either as an array or a single value.
 * @param value 任意类型的输入值，可以是数组、单个值或null/undefined。
 * @returns 返回一个数组或null。如果输入是数组，则直接返回该数组；
 *          如果输入是单个非空值，则返回包含该值的数组；
 *          如果输入是null或undefined，则返回null。
 */
export const ensureArrayOrValue = (value: any): any[] | null => {
  return Array?.isArray(value) ? value : value === 0 || value ? [value] : null
}
/**
 * 获取基于日期类型的文本背景处理函数。
 * 此函数根据传入的日期信息（dateInfo）、日期格式（dateFormat）以及日期类型（dateType）
 * 来决定如何处理日期并返回相应的字符串。支持两种日期类型：
 * - 'echoDate': 使用moment.js将日期对象转换为日期时间实例。
 * - 'formatEchoDate': 格式化日期对象为字符串。
 * 若未提供日期类型或设置为其他值，将默认执行格式化操作。
 * @param inputParams 参数对象，包含日期信息、日期格式和日期类型。
 * @returns 根据日期类型处理后的日期字符串，或在日期信息不存在时返回null。
 */
export const getDateTextHandler = (inputParams: any) => {
  const { dateInfo, dateFormat, dateType } = inputParams
  let textContent: any = ''
  switch (dateType) {
    case 'echoDate':
      textContent = transformAndEchoDate(dateInfo, dateFormat)
      break
    case 'formatEchoDate':
      textContent = formatAndEchoDate(dateInfo, dateFormat)
      break
    default:
      textContent = transformAndEchoDate(dateInfo, dateFormat)
  }
  return textContent
}
/**
 * 处理并输出日期范围的文本表示。
 * 此函数接收一个包含日期范围信息、日期格式及处理类型的参数对象（inputParams）。
 * 它会分别处理日期范围的开始和结束日期，利用`getDateTextHandler`函数对每个日期进行格式化或转换，
 * 然后以数组形式返回这两个处理后的日期。如果开始或结束日期任一存在，则返回两者处理后的结果；
 * 否则，返回null。
 * @param rangeDateParams 包含日期范围信息、格式及处理类型的参数对象。
 *   - dateInfo: 一个包含两个元素的数组，分别代表开始和结束日期。
 *   - dateFormat: 用于格式化的日期格式字符串。
 *   - dateType: 日期处理类型，指导如何处理日期。
 * @returns 一个数组，包含处理后的开始日期字符串和结束日期字符串，或在两者都缺失时返回null。
 */
export const handleAndEchoDateRange = (rangeDateParams: any) => {
  const { dateInfo = [], dateFormat = '', dateType } = rangeDateParams
  // 分别处理开始和结束日期
  const startDateStr = getDateTextHandler({ dateInfo: dateInfo?.[0], dateFormat, dateType })
  const endDateStr = getDateTextHandler({ dateInfo: dateInfo?.[1], dateFormat, dateType })
  // 如果开始或结束日期至少有一个存在，则组合返回
  return startDateStr || endDateStr ? [startDateStr, endDateStr] : null
}
// 附件表单处理
export const certificateFromData = (data: any) => {
  return data?.map((item: any) => (typeof item === 'string' ? item : item?.oss_key)) || []
}
// 数组项转成字符串
export const stringArray = (numberArray: any) => {
  return numberArray?.map((number: any) => number?.toString()) || null
}
/**
 * 从form_item中检索指定属性的字符串值。
 * 首先尝试从form_item的elementProps中获取属性值，如果不存在，则直接从form_item中获取。
 * 如果两者都未找到，则返回空字符串。
 * @param form_item 需要检索的数据对象，可能包含elementProps属性。
 * @param str 要检索的属性名称。
 * @returns 属性对应的字符串值，如果未找到则返回空字符串。
 */
export const retrieveStringProperty = (form_item: any, str: string): string => {
  return form_item?.elementProps?.[str] || form_item?.[str] || ''
}
/**
 * 获取数组的最后一个元素或非数组的原始值。
 * 此函数旨在提供一种统一的方式来处理数组和非数组值。当输入是一个数组时，它返回数组的最后一个元素；
 * 当输入不是数组时，它直接返回该值。这种设计使得调用者不需要关心具体的输入类型，简化了代码逻辑。
 * @param value 任意类型的输入值。可以是一个数组，也可以是任何其他类型的值。
 * @returns 如果输入是一个数组，则返回数组的最后一个元素；如果输入不是数组，则返回原始值。
 */
export const getLastElementOrValue = (value: any) => {
  return Array.isArray(value) ? value?.slice(-1)?.[0] : value
}
/**
 * 检查表单数据中是否存在指定字段。
 * 此函数接收一个表单数据对象（formData）和一个字段配置对象（field），并判断表单数据中
 * 是否包含该字段。它通过使用`hasOwnProperty`方法来确定字段是否存在。
 * @param formData 表单数据对象，可能包含多个字段值。
 * @param field 字段配置对象，包含待检查的字段名。
 * @returns 如果表单数据中存在指定字段，则返回true；否则返回false。
 */
const isFieldInFormData = (formData: any, field: any) => {
  return formData.hasOwnProperty(field)
}
/**
 * 根据动态表单数据和已提交的信息，处理并返回新的信息对象。
 * 主要处理日期选择器的日期格式化和阿里云OSS上传文件的证书数据格式化。
 * @param dynamicBasisForm 动态基础表单数据数组，每个项目包含表单列表。
 * @param info 已提交的信息对象，键为表单字段名，值为字段值。
 * @returns 返回一个对象，包含处理后的新信息对象。
 */
export const echoformData = (dynamicBasisForm: any, info: any) => {
  const info_new: any = {}
  dynamicBasisForm?.forEach((item: any) => {
    item?.form_list?.forEach((form_item: any) => {
      const specific_type = form_item?.specific_type || form_item?.type || ''
      const form_type = retrieveStringProperty(form_item, 'type')
      const big_data_select_name = [specific_type, form_type].includes('BigDataSelect')
      const mode_text = retrieveStringProperty(form_item, 'mode')
      const format_text = retrieveStringProperty(form_item, 'format')
      const value_name = form_item?.name || form_item?.formItemProps?.name || ''
      const is_array = Array.isArray(value_name) && value_name?.length > 0
      const value = is_array
        ? getValueByPath(info, value_name)
        : !is_array
          ? info[value_name]
          : null
      const is_select_multiple: boolean = mode_text === 'multiple'
      const is_form_value: boolean = isFieldInFormData(info, value_name)
      if (form_type === 'DatePicker' && is_form_value) {
        if (is_array) {
          setNestedValue(info_new, value_name, value)
        } else {
          info_new[value_name] = value
        }
      } else if (form_type === 'Switch') {
        const value_ = HSwitch.transform(value) || false
        console.log('value_Switch', value_)
        if (is_array) {
          setNestedValue(info_new, value_name, value_)
        } else {
          info_new[value_name] = value_
        }
      } else if (form_type === 'RangeDatePicker' && is_form_value) {
        if (is_array) {
          setNestedValue(info_new, value_name, value)
        } else {
          info_new[value_name] = value
        }
      } else if (form_type === 'FormImage' && is_form_value) {
        const value_ = certificateFromData(value || [])
        if (is_array) {
          setNestedValue(info_new, value_name, value_)
        } else {
          info_new[value_name] = value_
        }
      } else if ((big_data_select_name || ['Select'].includes(form_type)) && is_select_multiple) {
        let form_item_name: any
        if (value === 0 || value) {
          form_item_name = value
        } else {
          form_item_name = undefined
        }
        if (is_array) {
          setNestedValue(info_new, value_name, form_item_name)
        } else {
          info_new[value_name] = form_item_name
        }
      } else if ([specific_type].includes('CityCascader')) {
        const value_ = value_name ? info[`${value_name}s`] : null
        if (is_array) {
          setNestedValue(info_new, value_name, value_)
        } else {
          info_new[value_name] = value_
        }
      } else {
        if (is_array) {
          setNestedValue(info_new, value_name, value)
        } else {
          info_new[value_name] = value
        }
      }
    })
  })
  return { info_new }
}
/**
 * 根据表单配置及数据信息，转化并优化数据格式。
 * 此函数分析传入的表单结构（jsonForm）与数据实体（valueInfo），针对性地转换日期类型字段，
 * 确保非日期字段的正确处理（赋予null或原值），同时检测表单配置中是否有动态字段的指示。
 * @param formConfig 表单配置对象数组，描述了表单项的类型与名称等信息。
 * @param formData 需要转换格式的原始数据对象，对应用户填写或系统生成的数据。
 * @param [businessType] 业务类型标识，当前函数逻辑中未直接利用此参数。
 * @param [businessCode] 业务代码标识，同上，当前实现中未直接参与逻辑处理。
 * @returns 转换结果对象，结构如下：
 * - formattedData: 经过格式化处理后的数据，特别地，日期字段已按需转换格式。
 * - hasDynamicFields: 布尔值，指示表单配置中是否存在动态表单项。
 * - dynamicDataHolder: 用于存放动态生成的数据信息，默认为空对象，当前未实际填充数据。
 */
export const formatFormDataWithConfig = ({
  formConfig,
  formData
}: {
  formConfig: any
  formData: any
}) => {
  const formattedData: any = {}
  let hasDynamicFields = false
  // 遍历表单配置，处理数据
  formConfig?.forEach((section: any) => {
    hasDynamicFields = !!section?.form_list?.length
    section?.form_list?.forEach((field: any) => {
      const value_name = field?.name || field?.formItemProps?.name || ''
      const mode = findValuesByKeys(field, ['mode'])?.mode === 'multiple' ? 'multiple' : 'single'
      const specific_type = field?.specific_type || field?.type || ''
      const is_array = Array.isArray(value_name) && value_name?.length > 0
      const value = is_array
        ? getValueByPath(formData, value_name)
        : value_name
          ? formData[value_name]
          : null
      // const value = value_name?.length ? getValueByPath(formData, value_name) : null
      const form_type = retrieveStringProperty(field, 'type')
      const format_text = retrieveStringProperty(field, 'format')
      const is_form_value: boolean = isFieldInFormData(formData, value_name)
      if (form_type === 'DatePicker' && is_form_value) {
        // const value_ = getDateTextHandler({
        //   dateInfo: value,
        //   dateFormat: format_text || '',
        //   dateType: 'formatEchoDate'
        // })
        if (is_array) {
          setNestedValue(formattedData, value_name, value)
        } else {
          formattedData[value_name] = value
        }
      } else if (form_type === 'Switch' && is_form_value) {
        const initialValue = field?.formItemProps?.initialValue ? 1 : 0
        const value_ = HSwitch.transform(value, initialValue)
        if (is_array) {
          setNestedValue(formattedData, value_name, value_)
        } else {
          formattedData[value_name] = value_
        }
      } else if (form_type === 'RangeDatePicker' && is_form_value) {
        if (is_array) {
          setNestedValue(formattedData, value_name, value)
        } else {
          formattedData[value_name] = value
        }
      } else if (form_type === 'Personnel' && is_form_value) {
        if (mode === 'multiple') {
          formattedData[value_name] = value?.map((x: any) => x?.id)
        } else {
          const tempValue = Array.isArray(value) ? value?.[0] : value
          formattedData[value_name] = typeof tempValue === 'string' ? tempValue : tempValue?.id
        }
      } else if ([specific_type].includes('CityCascader')) {
        const value_ = getLastElementOrValue(value)
        if (is_array) {
          setNestedValue(formattedData, value_name, value_)
        } else {
          formattedData[value_name] = value_
        }
      } else {
        let form_item_name: any
        if (value === 0 || value) {
          form_item_name = value
        } else {
          form_item_name = null
        }
        if (is_array) {
          setNestedValue(formattedData, value_name, form_item_name)
        } else {
          formattedData[value_name] = form_item_name
        }
      }
    })
  })

  return { formattedData, hasDynamicFields }
}
/**
 * 将给定的信息根据动态基础表单格式进行转换。
 * @param dynamicBasisForm 动态基础表单数组，用于定义信息的结构和类型。
 * @param info 需要转换的信息对象，其键值对根据表单进行填充。
 * @returns 返回一个对象，包含转换后的信息和最后一个表单项的键名。
 */
export const transformData = (
  dynamicBasisForm: any,
  info: any,
  belongType?: any,
  belongCode?: any
) => {
  const info_new: any = {}
  const dynamic_info: any = {}
  let key_bool = false
  dynamicBasisForm?.forEach((item: any) => {
    key_bool = !!item?.form_list?.length
    item?.form_list?.forEach((form_item: any) => {
      // if (form_item?.type === 'DatePicker' && Object.keys(info).includes(form_item?.name)) {
      //   info_new[form_item?.name] = _formatDate(
      //     info[form_item?.name],
      //     form_item?.elementProps?.picker || 'date'
      //   )
      // } else {
      info_new[form_item?.name] = info[form_item?.name] || null
      // }
    })
  })
  if (key_bool) {
    dynamic_info[`${belongType}_dynamic_fields`] = [
      {
        employee_dynamic_field_group_code: belongCode,
        field_value: info_new || {}
      }
    ]
  }
  return { echo_info: info_new, key_bool, dynamic_info }
}
/**
 * 根据给定的参数创建一个包含动态信息的对象。
 * 此函数的目的是根据输入的参数，从一个给定的对象中提取出动态字段，并结合其他信息，构造一个新的对象返回。
 * 这个过程涉及到对原始对象的结构和数据的解构和重组，以满足特定的输出格式需求。
 * @param {any} fromValue - 原始数据对象，从中提取动态字段。
 * @param {string} belongType - 类型标识，用于指定在原始对象中查找动态字段的路径。
 * @param {string} belongCode - 代码标识，用于过滤动态字段中符合特定分组码的项。
 * @param {boolean} bool - 一个布尔值，用于决定是否将原始对象的对应类型数据合并到动态信息中。
 * @returns {any} 返回一个对象，其中包含动态信息和其他可能合并的数据。
 */
export function createValuesObject({
  fromValue,
  belongType,
  belongCode,
  bool
}: {
  fromValue: any
  belongType: string
  belongCode: string
  bool?: boolean
}): any {
  let belong_info: any = {}
  const dynamic_list = fromValue?.[`${belongType}_dynamic_fields`]?.filter((item: any) =>
    [belongCode].includes(item?.employee_dynamic_field_group_code)
  )
  if (!bool) {
    belong_info = fromValue?.[belongType] || {}
  }
  const dynamic_info: any = {
    ...(dynamic_list?.[0]?.field_value || {})
  }
  return { belong_info, dynamic_info }
}
// 深拷贝方法
export const cloneDeepData = (list: any) => {
  return cloneDeep(list || [])
}
/**
 * 根据传入的参数更新动态基础表单项的禁用状态。
 * 此函数接收一个包含动态基础表单数据和一个布尔值的对象作为参数。
 * 它的目的是遍历表单数据中的每个表单项，如果表单项自身包含禁用状态，
 * 则根据传入的布尔值决定是否将其禁用。如果表单项没有指定禁用状态，
 * 则根据传入的布尔值直接决定其禁用状态。
 * @param {Object} param0 包含动态基础表单数据和一个布尔值的对象。
 * @param {any[]} param0.dynamicBasisForm 动态基础表单的数据数组。
 * @param {boolean} param0.bool 用于决定表单项是否应该被禁用的布尔值。
 * @returns {any[]} 返回更新后的表单数据数组。
 */

export function updateFormItems({
  dynamicBasisForm,
  bool,
  islist = false
}: {
  dynamicBasisForm: any[]
  bool: boolean
  islist?: boolean
}): { formInfos: any[] } {
  // 使用lodash的cloneDeep进行深拷贝
  const formInfos = cloneDeepData(dynamicBasisForm)
  // console.log(formInfos, 'formInfos')
  // 遍历并更新formInfos
  formInfos.map((item: any) => {
    if (Array.isArray(item?.form_list)) {
      item.is_show_title = false
      item.form_list = item?.form_list
        ?.filter((formFilterItem: any) =>
          !islist
            ? !['FormImage', 'AliOSSUploadFile'].includes(formFilterItem?.type) &&
              formFilterItem?.special_flag !== 0
            : formFilterItem?.special_flag !== 0
        )
        ?.map((formItem: any) => {
          // 提高可读性，直接设定默认值
          const isDisabled = (formItem?.formItemProps?.disabled || formItem?.disabled) ?? false
          // 简化布尔逻辑
          const shouldDisable = bool || isDisabled
          if (islist) {
            formItem.disabled = shouldDisable
          } else {
            formItem.formItemProps.disabled = shouldDisable
          }
          const mode =
            (formItem?.mode || formItem?.elementProps?.mode) === '0' ? 'single' : 'multiple'
          const options = formItem?.elementProps?.options || formItem?.options || []
          const required = formItem?.formItemProps?.required || formItem?.required || false
          const name = formItem?.formItemProps?.name || formItem?.name || ''
          const label = formItem?.formItemProps?.label || formItem?.label || ''
          if (formItem.type === 'Select' && !formItem?.dictionary && options?.length > 0) {
            formItem.elementProps.options = options?.map((item: any) => ({
              ...item,
              name: item?.label
            }))
            formItem.options = []
            formItem.elementProps.mode = mode
            return {
              ...formItem,
              mode,
              fieldNames: { value: 'value', label: 'name' }
            }
          }
          if (formItem.type === 'Select' && formItem?.dictionary) {
            formItem.elementProps.mode = mode
            return {
              ...formItem,
              mode
            }
          }
          if (formItem.type === 'DatePicker' && !formItem?.picker) {
            return {
              ...{
                ...formItem,
                elementProps: {
                  type: 'date',
                  ...formItem?.elementProps
                }
              }
            }
          }
          if (formItem.type === 'Switch') {
            formItem.formItemProps.valuePropName = 'checked'
            return {
              ...formItem
            }
          }
          if (
            formItem.type === 'DatePicker' &&
            ['year', 'quarter', 'week', 'month'].includes(formItem?.picker)
          ) {
            return {
              ...formItem,
              type: 'DatePicker'
            }
          }
          if (formItem.type === 'TextArea') {
            return {
              ...formItem,
              type: 'Textarea'
            }
          }
          if (formItem.type === 'SearchFetchSelect') {
            return {
              ...formItem,
              type: 'Personnel',
              formItemProps: formItem?.formItemProps || {},
              filed: 'dynamic',
              elementProps: {
                mode: 'single',
                type: 'DAI_XUN_LAO_SHI',
                DAI_XUN_LAO_SHI: {
                  selectorParams: {
                    with_no_auth: true
                  },
                  personnelSearchRequestParams: {
                    with_no_auth: true
                  }
                }
              }
            }
          }
          if (formItem.type === 'AliOSSUploadFile') {
            return {
              type: 'FormImage',
              name,
              formItemProps: {
                label: '',
                name,
                className: ['class-c'],
                required
              },
              elementProps: {
                label,
                hasToken: true,
                disabled: shouldDisable,
                required
              }
            }
          }
          // 返回新对象以避免直接修改原始数据
          return {
            ...formItem
          }
        })
    }
    return item
  })
  return { formInfos }
}
/**
 * 合并基础表单与动态表单项列表。
 *
 * 此箭头函数接收一个配置对象，包含基础表单信息数组 (`commonInfo`) 和动态表单信息 (`dynamicInfos`)。
 * 它创建一个新的 `mergedFormInfos` 数组，其中每个基础表单项的 `form_list` 都已扩展，
 * 包含了来自 `dynamicInfos` 的 `form_list` 元素。这用于动态地向每个基础表单项添加额外的字段。
 * 若相关字段不存在，则默认为空数组，确保合并过程安全且不修改原始数据。
 *
 * @param {{ commonInfo: any[], dynamicInfos: any[] }} config - 包含基础表单信息和动态表单信息的配置对象。
 */
export const mergeBaseAndDynamicFormInfos = ({
  commonInfo,
  dynamicInfos
}: {
  commonInfo: any[]
  dynamicInfos: any
}): { mergedFormInfos: any } => {
  const mergedFormInfos: any = []
  commonInfo?.forEach((item: any) => {
    mergedFormInfos.push({
      ...item, // 保留基础表单项的原有属性
      form_list: [...(item?.form_list || []), ...dynamicInfos] // 合并动态表单项至基础表单项的 form_list
    })
  })
  return { mergedFormInfos }
}
/**
 * 构建归属类型关联数据。
 * 该函数用于根据传入的参数构建一个包含归属类型关联信息的对象。其中，归属类型由`belongType`指定，
 * 而具体的归属代码和员工ID等详细信息则通过其他参数传递。函数支持基础信息(`is_base`为true)和动态信息(`is_dynamic`为true)的组合，
 * 并根据这两种信息的状态来决定如何构建最终的对象。
 * @param {string} belongType 归属类型标识。
 * @param {string} belongCode 归属代码。
 * @param {string} staffId 员工ID，默认为空字符串。
 * @param {boolean} is_base 是否包含基础信息。
 * @param {boolean} is_dynamic 是否包含动态信息。
 * @param {Record<string, any>} base_info 基础信息对象。
 * @param {string} valid_start_date 基础信息的有效开始日期。
 * @param {Record<string, any>} dynamic_info 动态信息对象。
 * @returns 返回一个包含归属类型关联数据的对象。
 */

export const buildBelongTypeAssociation = ({
  belongType = '',
  belongCode = '',
  staffId = '',
  is_base = false,
  is_dynamic = false,
  base_info = {},
  dynamic_info = {},
  base_old_info = {},
  adjust_info = {}
}: {
  belongType?: string
  belongCode?: string
  staffId?: string
  is_base?: boolean
  is_dynamic?: boolean
  base_info?: Record<string, any>
  adjust_info?: any
  base_old_info?: any
  dynamic_info?: Record<string, any>
  valid_end_date?: any
}) => {
  const values: any = {
    employee_id: staffId
  }
  // 确保归属类型映射初始化
  values[`${belongType}_map`] = {}
  // 根据is_base和is_dynamic的值，构建归属类型关联数据
  if (is_base) {
    values[`${belongType}_map`] = {
      ...base_old_info,
      ...base_info,
      ...adjust_info
    }
  }
  if (is_dynamic) {
    // 如果is_base也为真，这里会添加或覆盖动态信息
    values[`${belongType}_map`][belongCode] = { ...dynamic_info }
  }

  return { values }
}
export function appendSuffixToLastElement(array: any, suffix = 's') {
  // 复制数组的最后一项并加上's'
  const lastElementWithS = array[array.length - 1] + suffix
  // 替换数组中的最后一个元素为新值
  array[array.length - 1] = lastElementWithS
  return array
}
export function setNestedValue<T = any>(obj: T, keys: string[], value: any): void {
  let current: any = obj
  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i]
    if (!current[key]) {
      current[key] = {} as T extends object ? T : {}
    }
    current = current[key]
  }
  current[keys[keys.length - 1]] = value
}
export function getValueByPath(obj: any, path: any) {
  if (isType(path) === 'string') {
    return obj?.[path]
  }
  return path?.reduce(
    (accumulator: any, key: number) =>
      accumulator && typeof accumulator === 'object' ? accumulator[key] : undefined,
    obj
  )
}
export const result_map: any = {
  2: 'employee_photo',
  4: 'salary_bank_photo',
  3: ['id_card_people', 'id_card_surface']
}
export const echoformNameArrayData = (dynamic_data: any, info: any) => {
  const info_object: Record<string, any> = {}
  dynamic_data?.forEach((item: any) => {
    item?.form_list?.forEach((form_item: any) => {
      const specific_type = form_item?.specific_type || form_item?.type || ''
      const form_type = retrieveStringProperty(form_item, 'type')
      const big_data_select_name = [specific_type, form_type].includes('BigDataSelect')
      const mode_text = retrieveStringProperty(form_item, 'mode')
      const format_text = retrieveStringProperty(form_item, 'format')
      const _value_name = form_item?.name || form_item?.formItemProps?.name
      const value_name = _value_name || []
      const value = value_name?.length ? getValueByPath(info, value_name) : null
      const is_select_multiple: boolean = mode_text === 'multiple'
      if (form_type === 'DatePicker') {
        const value_ = getDateTextHandler({
          dateInfo: value,
          dateFormat: format_text || '',
          dateType: 'echoDate'
        })
        setNestedValue(info_object, value_name, value_)
      } else if (form_type === 'Switch') {
        const value_ = HSwitch.transform(value)
        setNestedValue(info_object, value_name, value_)
      } else if (form_type === 'RangeDatePicker') {
        const value_ = handleAndEchoDateRange({
          dateInfo: value,
          dateFormat: format_text || '',
          dateType: 'echoDate'
        })
        setNestedValue(info_object, value_name, value_)
      } else if (form_type === 'Education') {
        setNestedValue(info_object, value_name, info?.base_map?.hrm_employee_educations)
      } else if (form_type === 'ModelPage') {
        setNestedValue(info_object, value_name, info?.base_map?.GONG_ZUO_JING_LI)
      } else if (form_type === 'AliOSSUploadFile') {
        const value_ = certificateFromData(value || [])
        setNestedValue(info_object, value_name, value_)
      } else if ((big_data_select_name || ['Select'].includes(form_type)) && is_select_multiple) {
        let form_item_name: any
        if (value === 0 || value) {
          form_item_name = value
        } else {
          form_item_name = []
        }
        setNestedValue(info_object, value_name, form_item_name)
      } else if ([form_type, specific_type].includes('CityCascader')) {
        const value_new_name = cloneDeepData(value_name)
        const text_name = value_new_name?.length ? appendSuffixToLastElement(value_new_name) : null
        const value_ = text_name?.length ? getValueByPath(info, text_name) : null
        setNestedValue(info_object, value_name, value_)
      } else if ([form_type, specific_type].includes('OrgSelectFilter')) {
        const orgId = info?.work_map?.org_id
        const orgName = info?.work_map?.org_name
        const org_info = {
          key: orgId,
          title: orgName
        }
        const org_id = orgId && orgName ? org_info : {}
        setNestedValue(info_object, value_name, org_id)
      } else if (form_type === 'FormImage') {
        // 附件类用FormImage标识
        // 人员附件特殊处理
        const keys = Object.keys(info?.hrm_employee_attachment_result?.attachments)
        if (keys?.length > 0) {
          keys.forEach((x: any) => {
            // eslint-disable-next-line max-nested-callbacks
            const oss_key = info?.hrm_employee_attachment_result?.attachments?.[x]?.map(
              (y: any) => y?.picture?.oss_key
            )
            if (Array.isArray(result_map[x])) {
              // eslint-disable-next-line max-nested-callbacks
              result_map[x].forEach((m: any, index: number) => {
                info_object[m] = [oss_key?.[index]]
              })
            } else info_object[result_map[x]] = oss_key
          })
        }
      } else {
        setNestedValue(info_object, value_name, value)
      }
    })
  })
  return { info_object }
}
/**
 * 根据表单配置及数据信息，转化并优化数据格式。
 * 此函数分析传入的表单结构（jsonForm）与数据实体（valueInfo），针对性地转换日期类型字段，
 * 确保非日期字段的正确处理（赋予null或原值），同时检测表单配置中是否有动态字段的指示。
 * @param formConfig 表单配置对象数组，描述了表单项的类型与名称等信息。
 * @param formData 需要转换格式的原始数据对象，对应用户填写或系统生成的数据。
 * @param [businessType] 业务类型标识，当前函数逻辑中未直接利用此参数。
 * @param [businessCode] 业务代码标识，同上，当前实现中未直接参与逻辑处理。
 * @returns 转换结果对象，结构如下：
 * - formattedData: 经过格式化处理后的数据，特别地，日期字段已按需转换格式。
 * - hasDynamicFields: 布尔值，指示表单配置中是否存在动态表单项。
 * - dynamicDataHolder: 用于存放动态生成的数据信息，默认为空对象，当前未实际填充数据。
 */
export const formatNameArrayWithConfig = ({
  formConfig,
  formData
}: {
  formConfig: any
  formData: any
}) => {
  const formattedData: any = {}
  let hasDynamicFields = false
  // 遍历表单配置，处理数据
  formConfig?.forEach((section: any) => {
    hasDynamicFields = !!section?.form_list?.length
    section?.form_list?.forEach((field: any) => {
      const value_name = field?.name || field?.formItemProps?.name || []
      const specific_type = field?.specific_type || field?.type || ''
      const value = value_name?.length ? getValueByPath(formData, value_name) : null
      const form_type = retrieveStringProperty(field, 'type')
      const format_text = retrieveStringProperty(field, 'format')
      if (form_type === 'DatePicker') {
        const value_ = getDateTextHandler({
          dateInfo: value,
          dateFormat: format_text || '',
          dateType: 'formatEchoDate'
        })
        setNestedValue(formattedData, value_name, value_)
      } else if (form_type === 'Switch') {
        const initialValue = field?.formItemProps?.initialValue ? 1 : 0
        const value_ = HSwitch.transform(value, initialValue)
        setNestedValue(formattedData, value_name, value_)
      } else if (form_type === 'RangeDatePicker') {
        const value_ = handleAndEchoDateRange({
          dateInfo: value,
          dateFormat: format_text || '',
          dateType: 'formatEchoDate'
        })
        setNestedValue(formattedData, value_name, value_)
      } else if ([specific_type].includes('CityCascader')) {
        const value_ = getLastElementOrValue(value)
        setNestedValue(formattedData, value_name, value_)
      } else if ([form_type, specific_type].includes('OrgSelectFilter')) {
        const org_id = formData?.work_map?.org_id?.key || null
        setNestedValue(formattedData, value_name, org_id)
      } else {
        let form_item_name: any
        if (value === 0 || value) {
          form_item_name = value
        } else {
          form_item_name = null
        }
        setNestedValue(formattedData, value_name, form_item_name)
      }
      if (field?.elementProps?.extraName) {
        setNestedValue(formattedData, field?.elementProps?.extraName, value)
      }
    })
  })

  return { formattedData, hasDynamicFields }
}
/**
 * 深度合并两个对象的属性。
 * @param target 被合并的对象，合并后的属性将修改此对象。
 * @param source 合并源对象，其属性将被合并到目标对象中。
 * @returns 返回合并后的目标对象。
 */
export function deepMerge(target: any, source: any) {
  Object.keys(source).forEach((key) => {
    const value = source[key]
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      if (!target.hasOwnProperty(key)) target[key] = {}
      deepMerge(target[key], value)
    } else if (value !== undefined && value !== null) {
      // 新增条件，跳过undefined和null值
      target[key] = value
    }
  })
  return target
}

export interface FlattenObjectResult {
  [key: string]: any
}
/**
 * 将嵌套对象深度展平为一维对象。
 * 该函数通过递归遍历输入对象的每个属性，将嵌套对象展平为一维对象，
 * 属性名通过点符号连接前缀和原始键名，以保持原始结构的引用。
 * 不支持数组作为值，因为数组的展平方式可能因使用场景而异。
 * @param obj 要展平的嵌套对象。
 * @param prefix 当前遍历层级的前缀，用于拼接键名。
 * @returns 返回展平后的一维对象。
 */
export function deepFlattenObject(obj: any, prefix = ''): FlattenObjectResult {
  return Object.entries(obj).reduce<FlattenObjectResult>((acc, [key, value]) => {
    const prefixedKey = prefix ? `${prefix}.${key}` : key
    if (
      typeof value === 'object' &&
      value !== null &&
      !Array.isArray(value) &&
      !dayjs.isDayjs(value)
    ) {
      return { ...acc, ...deepFlattenObject(value as any, prefixedKey) }
    }
    return { ...acc, [prefixedKey]: value }
  }, {})
}
export function checkMonthsDifference(start: any, end: any) {
  if (!start || !end) {
    return null
  }
  const startDate = dayjs(start)
  const endDate = dayjs(end)

  // 计算两个日期之间的月份差异
  const monthsDiff = endDate?.diff(startDate, 'months')

  // 检查月份差异是否在 [3, 6, 9, 12] 中
  const validDifferences = [3, 6, 9, 12]

  if (validDifferences?.includes(monthsDiff)) {
    return monthsDiff
  }

  return null
}
export function isNumber(val: any) {
  return typeof val === 'number' && !isNaN(val)
}
export function extractAndSplit(source: any, keysToExtract: string[]) {
  // 创建一个包含指定键的新对象
  const extracted = keysToExtract.reduce((acc: any, key: any) => {
    if (source.hasOwnProperty(key)) {
      acc[key] = source[key]
    }
    return acc
  }, {})
  // 使用解构赋值创建剩余的对象，排除掉提取的键
  const remainingKeys = Object.keys(source).filter((key) => !keysToExtract.includes(key))
  const rest = Object.assign({}, ...remainingKeys.map((key) => ({ [key]: source[key] })))
  const new_extracted = pick(extracted, keysToExtract)
  return { rest, extracted: new_extracted }
}
/**
 * 深度合并两个对象的属性。
 * @param target 被合并的对象，合并后的属性将修改此对象。
 * @param source 合并源对象，其属性将被合并到目标对象中。
 * @returns 返回合并后的目标对象。
 */
// 保留唯一的 deepMerge 定义
export function mergeNestedObjects(target: any, source: any) {
  Object.keys(source).forEach((key) => {
    const value = source[key]
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      if (!target.hasOwnProperty(key)) target[key] = {}
      mergeNestedObjects(target[key], value)
    } else if (value !== undefined && value !== null) {
      // 新增条件，跳过undefined和null值
      target[key] = value
    }
  })
  return target
}

// 辅助函数：判断是否为非空对象，且不包括数组
export function isObject(item: any) {
  return item && typeof item === 'object' && !Array.isArray(item)
}
export function isNonEmptyArray(value: any) {
  return Array.isArray(value) && value?.length > 0
}

export function extractNameArrays(fields: any) {
  return (
    fields
      ?.filter((field: any) => isNonEmptyArray(field?.formItemProps?.name || field?.name))
      ?.map((field: any) => field?.formItemProps?.name || field?.name) || []
  )
}
export function buildNestedObject(paths: any) {
  return paths.reduce((acc: any, path: any) => {
    path.reduce((currentLevel: any, segment: any, index: any) => {
      currentLevel[segment] = currentLevel[segment] ?? (index < path.length - 1 ? {} : null)
      return currentLevel[segment]
    }, acc)
    return acc
  }, {})
}
export function extractMatchingKeys(source: any, template: any) {
  function recurse(src: any, tmpl: any, ext: any = {}, omt: any) {
    for (const key in tmpl) {
      if (key in src) {
        if (typeof src[key] === 'object' && typeof tmpl[key] === 'object') {
          ext[key] = Array.isArray(tmpl[key]) ? [] : {}
          recurse(src[key], tmpl[key], ext[key], omt[key])
          // If the current level becomes empty after recursion, remove it from omitted
          if (Object.keys(omt[key]).length === 0) {
            delete omt[key]
          }
        } else {
          ext[key] = src[key]
          delete omt[key] // Remove from omitted object
        }
      }
    }
    return { ext, omt }
  }

  // Deep copy of the source object to create the omitted object
  const omitted = JSON.parse(JSON.stringify(source))
  // Start recursion from the root level and get both extracted and omitted objects
  const { ext: extracted, omt: cleanedOmitted } = recurse(source, template, {}, omitted)

  return { retainedObject: extracted, extractedObject: cleanedOmitted }
}
export function separateFormItemsByType(formInfo: any) {
  return formInfo
    ?.map((section: any) => {
      const stringNameItems = section.form_list.filter(
        (item: any) => typeof (item?.formItemProps?.name || item?.name) === 'string'
      )
      const arrayNameItems = section.form_list.filter((item: any) =>
        Array.isArray(item?.formItemProps?.name || item?.name)
      )

      // Create two new sections based on the filtered items
      const stringSection =
        stringNameItems?.length > 0
          ? {
              ...section,
              form_list: stringNameItems
            }
          : null

      const arraySection =
        arrayNameItems?.length > 0
          ? {
              ...section,
              form_list: arrayNameItems
            }
          : null

      return { stringSection, arraySection }
    })
    .reduce(
      (acc: any, { stringSection, arraySection }: any) => {
        if (stringSection) acc.stringFormInfo.push(stringSection)
        if (arraySection) acc.arrayFormInfo.push(arraySection)
        return acc
      },
      { stringFormInfo: [], arrayFormInfo: [] }
    )
}
export const generateFormInfo = ({
  fromValue,
  originOption,
  dynamicBasisForm,
  belongType,
  belongCode
}: any) => {
  const clonedFromValue = cloneDeep(fromValue)
  const clonedOriginOption = cloneDeep(originOption)
  const clonedTwoOriginOption = cloneDeep(originOption)
  const formList = clonedOriginOption?.formInfo?.[0]?.form_list || []
  const nameArrays = extractNameArrays(formList)

  const { stringFormInfo, arrayFormInfo } = separateFormItemsByType(
    clonedTwoOriginOption?.formInfo || []
  )
  const hasNameArrays = nameArrays?.length > 0

  const nestedObject = hasNameArrays ? buildNestedObject(nameArrays) : {}
  const { retainedObject, extractedObject } = hasNameArrays
    ? extractMatchingKeys(clonedFromValue, nestedObject)
    : { retainedObject: {}, extractedObject: fromValue }

  const baseInfo = extractedObject?.[`${belongType}_map`] || {}
  const dynamicInfo = baseInfo?.[`${belongCode}`] || {}
  const dynamicArraysInfo = retainedObject || {}

  const { info_new: dynamicInfoItem } = echoformData(dynamicBasisForm, dynamicInfo)
  const { info_new: baseInfoItem } = echoformData(stringFormInfo || [], baseInfo)
  const { info_new: baseArrayInfoItem } = hasNameArrays
    ? echoformData(arrayFormInfo || [], dynamicArraysInfo)
    : { info_new: {} }

  return {
    ...baseInfoItem,
    ...dynamicInfoItem,
    ...baseArrayInfoItem
  }
}
// 定义字段类型
interface FormField {
  type: string
  name: string
  formItemProps?: {
    required?: boolean
  }
}

// 查找规则函数
function findNameByRule(data: FormField[], typesOrder: string[]) {
  // 第一优先级：required === true
  for (const type of typesOrder) {
    const found: any = data.find(
      (item) =>
        item.type === type &&
        (item.formItemProps?.required || item.formItemProps?.required) === true
    )
    const name = found?.name || found?.formItemProps?.name
    if (name) {
      return { name: name + (['BigDataSelect', 'Select'].includes(type) ? '_name' : ''), type }
    }
  }

  // 第二优先级：required !== true 或未设置
  for (const type of typesOrder) {
    const found: any = data.find(
      (item) =>
        item.type === type &&
        (item.formItemProps?.required || item.formItemProps?.required) !== true
    )
    const name = found?.name || found?.formItemProps?.name
    if (name) {
      return { name: name + (['BigDataSelect', 'Select'].includes(type) ? '_name' : ''), type }
    }
  }

  return { name: null, type: null }
}

// 主分析函数
export function analyzeFormFields(list: FormField[] = []) {
  const typesOrder_name = [
    'Input',
    'TextArea',
    'InputNumber',
    'BigDataSelect',
    'Select',
    'DatePicker',
    'Switch',
    'FormImage'
  ]
  const typesOrder_note = [
    'DatePicker',
    'Input',
    'TextArea',
    'BigDataSelect',
    'InputNumber',
    'Select',
    'Switch',
    'FormImage'
  ]
  const len = list.length
  console.log(list, 'list####', typesOrder_name)
  const bool = len > 1
  const { name, type } =
    len > 0 ? findNameByRule(list, typesOrder_name) : { name: null, type: null }

  let name_note = null
  let type_note = null

  if (name && bool) {
    const filteredData = list.filter((item) => item.name !== name)
    const result = findNameByRule(filteredData, typesOrder_note)
    name_note = result?.name || null
    type_note = result?.type || null
  }
  return { name, type, name_note, type_note }
}
export const contentName = (x: any, str: any, _type: any) => {
  return ['Input', 'TextArea', 'InputNumber', 'Select', 'DatePicker'].includes(_type || '')
    ? x?.[str]
    : _type === 'Switch' && !!x?.[str]
      ? '开启'
      : _type === 'Switch' && !x?.[str]
        ? '关闭'
        : _type === 'FormImage'
          ? '附件'
          : '-'
}
